module.exports = __webpack_public_path__ + "img/SER-B-2-I.5a1f082e.png";